/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  BillingSummary,
  CancelChargeRequest,
  Charge,
  ChargePage,
  ConflictResponse,
  CreateChargeRequest,
  CreateCheckoutSessionRequest,
  CreatePriceRequest,
  CreateSubscriptionRequest,
  DunningPolicy,
  ForbiddenResponse,
  HostedSession,
  ListChargesParams,
  ListMyChargesParams,
  ListSubscriptionsParams,
  ListWebhookEventsParams,
  NotFoundResponse,
  OpaqueWebhookPayload,
  PaymentMethodAvailability,
  Price,
  Problem,
  PutDunningPolicyRequest,
  RecordManualPaymentRequest,
  RefundChargeRequest,
  ReprocessWebhookEventRequest,
  ServiceUnavailableResponse,
  Subscription,
  SubscriptionPage,
  UnauthorizedResponse,
  UnprocessableEntityResponse,
  UpdatePriceRequest,
  WebhookEvent,
  WebhookEventPage
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetMyBillingUrl = () => {




  return `/v1/me/billing`
}

/**
 * Situacao financeira do aluno autenticado: faturas, assinaturas, saldo em
 * aberto, comprovantes e o proximo vencimento numa resposta so.
 *
 * O portal do aluno nunca recebe dado de cartao: numero, validade e CVV
 * vivem na Stripe e nunca atravessam esta API.
 * @summary Situacao financeira do proprio aluno
 */
export const getMyBilling = async ( options?: Parameters<typeof apiFetch>[1]): Promise<BillingSummary> => {

  return apiFetch<BillingSummary>(getGetMyBillingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyBillingQueryKey = () => {
    return [
    `/v1/me/billing`
    ] as const;
    }


export const getGetMyBillingQueryOptions = <TData = Awaited<ReturnType<typeof getMyBilling>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBilling>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyBillingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBilling>>> = ({ signal }) => getMyBilling({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyBilling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyBillingQueryResult = NonNullable<Awaited<ReturnType<typeof getMyBilling>>>
export type GetMyBillingQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetMyBilling<TData = Awaited<ReturnType<typeof getMyBilling>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBilling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBilling>>,
          TError,
          Awaited<ReturnType<typeof getMyBilling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBilling<TData = Awaited<ReturnType<typeof getMyBilling>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBilling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBilling>>,
          TError,
          Awaited<ReturnType<typeof getMyBilling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBilling<TData = Awaited<ReturnType<typeof getMyBilling>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBilling>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Situacao financeira do proprio aluno
 */

export function useGetMyBilling<TData = Awaited<ReturnType<typeof getMyBilling>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBilling>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyBillingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMyChargesUrl = (params?: ListMyChargesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/me/charges?${stringifiedParams}` : `/v1/me/charges`
}

/**
 * Lista as obrigacoes financeiras do aluno autenticado, com estado e
 * vencimento, em ordem cronologica reversa.
 * @summary Lista as proprias obrigacoes financeiras
 */
export const listMyCharges = async (params?: ListMyChargesParams, options?: Parameters<typeof apiFetch>[1]): Promise<ChargePage> => {

  return apiFetch<ChargePage>(getListMyChargesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyChargesQueryKey = (params?: ListMyChargesParams,) => {
    return [
    `/v1/me/charges`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMyChargesQueryOptions = <TData = Awaited<ReturnType<typeof listMyCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListMyChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyChargesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyCharges>>> = ({ signal }) => listMyCharges(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyCharges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyChargesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyCharges>>>
export type ListMyChargesQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListMyCharges<TData = Awaited<ReturnType<typeof listMyCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListMyChargesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyCharges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyCharges>>,
          TError,
          Awaited<ReturnType<typeof listMyCharges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyCharges<TData = Awaited<ReturnType<typeof listMyCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMyChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyCharges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyCharges>>,
          TError,
          Awaited<ReturnType<typeof listMyCharges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyCharges<TData = Awaited<ReturnType<typeof listMyCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMyChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as proprias obrigacoes financeiras
 */

export function useListMyCharges<TData = Awaited<ReturnType<typeof listMyCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMyChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyChargesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMyPaymentMethodsUrl = () => {




  return `/v1/me/payment-methods`
}

/**
 * Lista os meios de pagamento habilitados para o aluno autenticado.
 *
 * Pix so aparece quando o aluno tem CPF cadastrado **e** a conta Stripe da
 * escola tem 60 dias de historico de processamento. O valor `pix` existe no
 * enum desde ja porque o portao e de disponibilidade, nao de formato.
 *
 * A resposta nao carrega dado de cartao — apenas quais meios estao
 * habilitados e por que um deles nao esta.
 * @summary Lista os meios de pagamento disponiveis ao aluno
 */
export const listMyPaymentMethods = async ( options?: Parameters<typeof apiFetch>[1]): Promise<PaymentMethodAvailability> => {

  return apiFetch<PaymentMethodAvailability>(getListMyPaymentMethodsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyPaymentMethodsQueryKey = () => {
    return [
    `/v1/me/payment-methods`
    ] as const;
    }


export const getListMyPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof listMyPaymentMethods>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyPaymentMethodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyPaymentMethods>>> = ({ signal }) => listMyPaymentMethods({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyPaymentMethods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyPaymentMethods>>>
export type ListMyPaymentMethodsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListMyPaymentMethods<TData = Awaited<ReturnType<typeof listMyPaymentMethods>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPaymentMethods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listMyPaymentMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyPaymentMethods<TData = Awaited<ReturnType<typeof listMyPaymentMethods>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPaymentMethods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof listMyPaymentMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyPaymentMethods<TData = Awaited<ReturnType<typeof listMyPaymentMethods>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os meios de pagamento disponiveis ao aluno
 */

export function useListMyPaymentMethods<TData = Awaited<ReturnType<typeof listMyPaymentMethods>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPaymentMethods>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateBillingPortalSessionUrl = () => {




  return `/v1/me/billing-portal-session`
}

/**
 * Cria uma sessao do Customer Portal hospedado da Stripe e devolve a URL
 * para a qual a SPA redireciona. A SPA nao manipula dado de cartao em
 * nenhum momento: o portal e hospedado.
 * @summary Abre uma sessao do portal de cobranca hospedado
 */
export const createBillingPortalSession = async ( options?: Parameters<typeof apiFetch>[1]): Promise<HostedSession> => {

  return apiFetch<HostedSession>(getCreateBillingPortalSessionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateBillingPortalSessionMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,void, TContext> => {

const mutationKey = ['createBillingPortalSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingPortalSession>>, void> = () => {


          return  createBillingPortalSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingPortalSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingPortalSession>>>

    export type CreateBillingPortalSessionMutationError = UnauthorizedResponse | ForbiddenResponse | ServiceUnavailableResponse

    /**
 * @summary Abre uma sessao do portal de cobranca hospedado
 */
export const useCreateBillingPortalSession = <TError = UnauthorizedResponse | ForbiddenResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBillingPortalSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateBillingPortalSessionMutationOptions(options), queryClient);
    }
    export const getCreateCheckoutSessionUrl = () => {




  return `/v1/checkout-sessions`
}

/**
 * Cria uma sessao de Checkout hospedado da Stripe para uma obrigacao do
 * proprio aluno e devolve a URL de redirecionamento. A SPA redireciona e
 * nao manipula dado de cartao.
 *
 * **Preco esta aberto na §15.2** e nasce como um centavo. Enquanto o preco
 * for provisorio, esta operacao responde 503: um centavo passa no checkout
 * e ninguem o confunde com uma mensalidade, mas cobrar por engano tambem
 * nao serve.
 *
 * Moeda unica BRL. O custo de cambio de cartao internacional cai no aluno,
 * pelo banco emissor, e nao na plataforma. Pix exige CPF do pagador e por
 * isso o CPF, opcional na matricula, e condicionalmente obrigatorio aqui.
 * @summary Abre um checkout hospedado para uma obrigacao propria
 */
export const createCheckoutSession = async (createCheckoutSessionRequest: CreateCheckoutSessionRequest, options?: Parameters<typeof apiFetch>[1]): Promise<HostedSession> => {

  return apiFetch<HostedSession>(getCreateCheckoutSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCheckoutSessionRequest)
  }
);}





export const getCreateCheckoutSessionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{data: CreateCheckoutSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{data: CreateCheckoutSessionRequest}, TContext> => {

const mutationKey = ['createCheckoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCheckoutSession>>, {data: CreateCheckoutSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCheckoutSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createCheckoutSession>>>
    export type CreateCheckoutSessionMutationBody = CreateCheckoutSessionRequest
    export type CreateCheckoutSessionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | ServiceUnavailableResponse

    /**
 * @summary Abre um checkout hospedado para uma obrigacao propria
 */
export const useCreateCheckoutSession = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCheckoutSession>>, TError,{data: CreateCheckoutSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCheckoutSession>>,
        TError,
        {data: CreateCheckoutSessionRequest},
        TContext
      > => {
      return useMutation(getCreateCheckoutSessionMutationOptions(options), queryClient);
    }
    export const getListChargesUrl = (params?: ListChargesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/charges?${stringifiedParams}` : `/v1/charges`
}

/**
 * Lista obrigacoes financeiras de todos os alunos, com filtro por estado,
 * pessoa e periodo. Exclusiva de Super Admin.
 * @summary Lista obrigacoes financeiras de todos os alunos
 */
export const listCharges = async (params?: ListChargesParams, options?: Parameters<typeof apiFetch>[1]): Promise<ChargePage> => {

  return apiFetch<ChargePage>(getListChargesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListChargesQueryKey = (params?: ListChargesParams,) => {
    return [
    `/v1/charges`, ...(params ? [params] : [])
    ] as const;
    }


export const getListChargesQueryOptions = <TData = Awaited<ReturnType<typeof listCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListChargesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCharges>>> = ({ signal }) => listCharges(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCharges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListChargesQueryResult = NonNullable<Awaited<ReturnType<typeof listCharges>>>
export type ListChargesQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListCharges<TData = Awaited<ReturnType<typeof listCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListChargesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCharges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCharges>>,
          TError,
          Awaited<ReturnType<typeof listCharges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCharges<TData = Awaited<ReturnType<typeof listCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCharges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCharges>>,
          TError,
          Awaited<ReturnType<typeof listCharges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCharges<TData = Awaited<ReturnType<typeof listCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista obrigacoes financeiras de todos os alunos
 */

export function useListCharges<TData = Awaited<ReturnType<typeof listCharges>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListChargesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListChargesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateChargeUrl = () => {




  return `/v1/charges`
}

/**
 * Cria uma obrigacao financeira avulsa para um aluno. Exclusiva de Super
 * Admin.
 *
 * **Preco esta aberto na §15.2** e nasce como um centavo. Enquanto o preco
 * for provisorio, esta operacao responde 503, pela mesma razao de
 * `createCheckoutSession`: emitir obrigacao com valor de placeholder e
 * cobrar por engano.
 *
 * `dueOn` e obrigatorio no pedido. Prazo de vencimento e politica
 * comercial e continua aberto; um pedido sem vencimento obrigaria o
 * servidor a escolher um, e escolher aqui seria inventar a politica em vez
 * de esperar por ela.
 * @summary Cria uma obrigacao financeira avulsa
 */
export const createCharge = async (createChargeRequest: CreateChargeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Charge> => {

  return apiFetch<Charge>(getCreateChargeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createChargeRequest)
  }
);}





export const getCreateChargeMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCharge>>, TError,{data: CreateChargeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCharge>>, TError,{data: CreateChargeRequest}, TContext> => {

const mutationKey = ['createCharge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCharge>>, {data: CreateChargeRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCharge(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChargeMutationResult = NonNullable<Awaited<ReturnType<typeof createCharge>>>
    export type CreateChargeMutationBody = CreateChargeRequest
    export type CreateChargeMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse

    /**
 * @summary Cria uma obrigacao financeira avulsa
 */
export const useCreateCharge = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCharge>>, TError,{data: CreateChargeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCharge>>,
        TError,
        {data: CreateChargeRequest},
        TContext
      > => {
      return useMutation(getCreateChargeMutationOptions(options), queryClient);
    }
    export const getRefundChargeUrl = (chargeId: string,) => {




  return `/v1/charges/${chargeId}/refund`
}

/**
 * Estorna uma obrigacao ja paga. Exclusiva de Super Admin e sensivel:
 * exige reautenticacao recente e justificativa, e entra na trilha de
 * auditoria.
 * @summary Reembolsa uma obrigacao paga
 */
export const refundCharge = async (chargeId: string,
    refundChargeRequest: RefundChargeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Charge> => {

  return apiFetch<Charge>(getRefundChargeUrl(chargeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refundChargeRequest)
  }
);}





export const getRefundChargeMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundCharge>>, TError,{chargeId: string;data: RefundChargeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refundCharge>>, TError,{chargeId: string;data: RefundChargeRequest}, TContext> => {

const mutationKey = ['refundCharge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refundCharge>>, {chargeId: string;data: RefundChargeRequest}> = (props) => {
          const {chargeId,data} = props ?? {};

          return  refundCharge(chargeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefundChargeMutationResult = NonNullable<Awaited<ReturnType<typeof refundCharge>>>
    export type RefundChargeMutationBody = RefundChargeRequest
    export type RefundChargeMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Reembolsa uma obrigacao paga
 */
export const useRefundCharge = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundCharge>>, TError,{chargeId: string;data: RefundChargeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refundCharge>>,
        TError,
        {chargeId: string;data: RefundChargeRequest},
        TContext
      > => {
      return useMutation(getRefundChargeMutationOptions(options), queryClient);
    }
    export const getCancelChargeUrl = (chargeId: string,) => {




  return `/v1/charges/${chargeId}/cancel`
}

/**
 * Cancela uma obrigacao ainda nao paga. Exclusiva de Super Admin e
 * sensivel: exige reautenticacao recente.
 * @summary Cancela uma obrigacao ainda nao paga
 */
export const cancelCharge = async (chargeId: string,
    cancelChargeRequest: CancelChargeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Charge> => {

  return apiFetch<Charge>(getCancelChargeUrl(chargeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelChargeRequest)
  }
);}





export const getCancelChargeMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCharge>>, TError,{chargeId: string;data: CancelChargeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelCharge>>, TError,{chargeId: string;data: CancelChargeRequest}, TContext> => {

const mutationKey = ['cancelCharge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelCharge>>, {chargeId: string;data: CancelChargeRequest}> = (props) => {
          const {chargeId,data} = props ?? {};

          return  cancelCharge(chargeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelChargeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelCharge>>>
    export type CancelChargeMutationBody = CancelChargeRequest
    export type CancelChargeMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Cancela uma obrigacao ainda nao paga
 */
export const useCancelCharge = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCharge>>, TError,{chargeId: string;data: CancelChargeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelCharge>>,
        TError,
        {chargeId: string;data: CancelChargeRequest},
        TContext
      > => {
      return useMutation(getCancelChargeMutationOptions(options), queryClient);
    }
    export const getRecordManualPaymentUrl = (chargeId: string,) => {




  return `/v1/charges/${chargeId}/manual-payment`
}

/**
 * Registra a baixa manual de um pagamento recebido fora da plataforma.
 * Exclusiva de Super Admin e sensivel. Toda baixa manual entra na trilha
 * de auditoria com autor e justificativa.
 * @summary Registra um pagamento recebido fora da plataforma
 */
export const recordManualPayment = async (chargeId: string,
    recordManualPaymentRequest: RecordManualPaymentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Charge> => {

  return apiFetch<Charge>(getRecordManualPaymentUrl(chargeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordManualPaymentRequest)
  }
);}





export const getRecordManualPaymentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordManualPayment>>, TError,{chargeId: string;data: RecordManualPaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordManualPayment>>, TError,{chargeId: string;data: RecordManualPaymentRequest}, TContext> => {

const mutationKey = ['recordManualPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordManualPayment>>, {chargeId: string;data: RecordManualPaymentRequest}> = (props) => {
          const {chargeId,data} = props ?? {};

          return  recordManualPayment(chargeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordManualPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordManualPayment>>>
    export type RecordManualPaymentMutationBody = RecordManualPaymentRequest
    export type RecordManualPaymentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Registra um pagamento recebido fora da plataforma
 */
export const useRecordManualPayment = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordManualPayment>>, TError,{chargeId: string;data: RecordManualPaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordManualPayment>>,
        TError,
        {chargeId: string;data: RecordManualPaymentRequest},
        TContext
      > => {
      return useMutation(getRecordManualPaymentMutationOptions(options), queryClient);
    }
    export const getListSubscriptionsUrl = (params?: ListSubscriptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/subscriptions?${stringifiedParams}` : `/v1/subscriptions`
}

/**
 * Lista as assinaturas recorrentes de todos os alunos. Exclusiva de Super
 * Admin.
 * @summary Lista assinaturas
 */
export const listSubscriptions = async (params?: ListSubscriptionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<SubscriptionPage> => {

  return apiFetch<SubscriptionPage>(getListSubscriptionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSubscriptionsQueryKey = (params?: ListSubscriptionsParams,) => {
    return [
    `/v1/subscriptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listSubscriptions>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubscriptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubscriptions>>> = ({ signal }) => listSubscriptions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSubscriptions>>>
export type ListSubscriptionsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListSubscriptions<TData = Awaited<ReturnType<typeof listSubscriptions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListSubscriptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSubscriptions<TData = Awaited<ReturnType<typeof listSubscriptions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof listSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSubscriptions<TData = Awaited<ReturnType<typeof listSubscriptions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista assinaturas
 */

export function useListSubscriptions<TData = Awaited<ReturnType<typeof listSubscriptions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSubscriptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateSubscriptionUrl = () => {




  return `/v1/subscriptions`
}

/**
 * Cria uma assinatura recorrente para um aluno. O preco esta aberto na
 * §15.2 e nasce provisorio em um centavo; enquanto o preco for provisorio,
 * esta operacao responde 503.
 * @summary Cria uma assinatura recorrente
 */
export const createSubscription = async (createSubscriptionRequest: CreateSubscriptionRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Subscription> => {

  return apiFetch<Subscription>(getCreateSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSubscriptionRequest)
  }
);}





export const getCreateSubscriptionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{data: CreateSubscriptionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{data: CreateSubscriptionRequest}, TContext> => {

const mutationKey = ['createSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscription>>, {data: CreateSubscriptionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createSubscription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscription>>>
    export type CreateSubscriptionMutationBody = CreateSubscriptionRequest
    export type CreateSubscriptionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ServiceUnavailableResponse

    /**
 * @summary Cria uma assinatura recorrente
 */
export const useCreateSubscription = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{data: CreateSubscriptionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscription>>,
        TError,
        {data: CreateSubscriptionRequest},
        TContext
      > => {
      return useMutation(getCreateSubscriptionMutationOptions(options), queryClient);
    }
    export const getCancelSubscriptionUrl = (subscriptionId: string,) => {




  return `/v1/subscriptions/${subscriptionId}`
}

/**
 * Cancela uma assinatura recorrente. Exclusiva de Super Admin e sensivel:
 * exige reautenticacao recente.
 * @summary Cancela uma assinatura
 */
export const cancelSubscription = async (subscriptionId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getCancelSubscriptionUrl(subscriptionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCancelSubscriptionMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,{subscriptionId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,{subscriptionId: string}, TContext> => {

const mutationKey = ['cancelSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSubscription>>, {subscriptionId: string}> = (props) => {
          const {subscriptionId} = props ?? {};

          return  cancelSubscription(subscriptionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSubscription>>>

    export type CancelSubscriptionMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Cancela uma assinatura
 */
export const useCancelSubscription = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,{subscriptionId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSubscription>>,
        TError,
        {subscriptionId: string},
        TContext
      > => {
      return useMutation(getCancelSubscriptionMutationOptions(options), queryClient);
    }
    export const getListPricesUrl = () => {




  return `/v1/prices`
}

/**
 * Lista os precos configurados no catalogo. Exclusiva de Super Admin.
 *
 * **Os valores estao abertos na §15.2** — preco do plano, preco de dupla
 * por aluno, taxa de matricula, cupons, multa e juros. O preco nasce em um
 * centavo e marcado como provisorio. Ate 16/08/2026 isso RECUSAVA a subida em
 * producao; hoje a pendencia aparece em listPlatformPendencies, e o preco de
 * um centavo e cobrado de verdade enquanto nao for ratificado.
 * @summary Lista precos configurados
 */
export const listPrices = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Price[]> => {

  return apiFetch<Price[]>(getListPricesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricesQueryKey = () => {
    return [
    `/v1/prices`
    ] as const;
    }


export const getListPricesQueryOptions = <TData = Awaited<ReturnType<typeof listPrices>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrices>>> = ({ signal }) => listPrices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPrices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPricesQueryResult = NonNullable<Awaited<ReturnType<typeof listPrices>>>
export type ListPricesQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListPrices<TData = Awaited<ReturnType<typeof listPrices>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrices>>,
          TError,
          Awaited<ReturnType<typeof listPrices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrices<TData = Awaited<ReturnType<typeof listPrices>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrices>>,
          TError,
          Awaited<ReturnType<typeof listPrices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrices<TData = Awaited<ReturnType<typeof listPrices>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista precos configurados
 */

export function useListPrices<TData = Awaited<ReturnType<typeof listPrices>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPricesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreatePriceUrl = () => {




  return `/v1/prices`
}

/**
 * Cria um preco no catalogo. Exclusiva de Super Admin e sensivel.
 * @summary Cria um preco
 */
export const createPrice = async (createPriceRequest: CreatePriceRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Price> => {

  return apiFetch<Price>(getCreatePriceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPriceRequest)
  }
);}





export const getCreatePriceMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPrice>>, TError,{data: CreatePriceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPrice>>, TError,{data: CreatePriceRequest}, TContext> => {

const mutationKey = ['createPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPrice>>, {data: CreatePriceRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPrice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceMutationResult = NonNullable<Awaited<ReturnType<typeof createPrice>>>
    export type CreatePriceMutationBody = CreatePriceRequest
    export type CreatePriceMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse

    /**
 * @summary Cria um preco
 */
export const useCreatePrice = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPrice>>, TError,{data: CreatePriceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPrice>>,
        TError,
        {data: CreatePriceRequest},
        TContext
      > => {
      return useMutation(getCreatePriceMutationOptions(options), queryClient);
    }
    export const getUpdatePriceUrl = (priceId: string,) => {




  return `/v1/prices/${priceId}`
}

/**
 * Altera um preco do catalogo. Exclusiva de Super Admin e sensivel.
 * Alterar preco nao altera obrigacao ja emitida: o valor e congelado na
 * emissao.
 * @summary Altera um preco
 */
export const updatePrice = async (priceId: string,
    updatePriceRequest: UpdatePriceRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Price> => {

  return apiFetch<Price>(getUpdatePriceUrl(priceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePriceRequest)
  }
);}





export const getUpdatePriceMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePrice>>, TError,{priceId: string;data: UpdatePriceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePrice>>, TError,{priceId: string;data: UpdatePriceRequest}, TContext> => {

const mutationKey = ['updatePrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePrice>>, {priceId: string;data: UpdatePriceRequest}> = (props) => {
          const {priceId,data} = props ?? {};

          return  updatePrice(priceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceMutationResult = NonNullable<Awaited<ReturnType<typeof updatePrice>>>
    export type UpdatePriceMutationBody = UpdatePriceRequest
    export type UpdatePriceMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse

    /**
 * @summary Altera um preco
 */
export const useUpdatePrice = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePrice>>, TError,{priceId: string;data: UpdatePriceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePrice>>,
        TError,
        {priceId: string;data: UpdatePriceRequest},
        TContext
      > => {
      return useMutation(getUpdatePriceMutationOptions(options), queryClient);
    }
    export const getGetDunningPolicyUrl = () => {




  return `/v1/dunning-policy`
}

/**
 * Le a politica de inadimplencia vigente. Exclusiva de Super Admin.
 *
 * **A politica esta aberta na §15.2**: dias de atraso que bloqueiam acesso
 * e se o bloqueio derruba aula ja agendada. Enquanto for provisoria, ela
 * apura e nao bloqueia. A recusa de subida que existia ate 16/08/2026 virou a
 * pendencia que listPlatformPendencies devolve.
 * @summary Le a politica de inadimplencia
 */
export const getDunningPolicy = async ( options?: Parameters<typeof apiFetch>[1]): Promise<DunningPolicy> => {

  return apiFetch<DunningPolicy>(getGetDunningPolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDunningPolicyQueryKey = () => {
    return [
    `/v1/dunning-policy`
    ] as const;
    }


export const getGetDunningPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getDunningPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDunningPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDunningPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDunningPolicy>>> = ({ signal }) => getDunningPolicy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDunningPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDunningPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getDunningPolicy>>>
export type GetDunningPolicyQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetDunningPolicy<TData = Awaited<ReturnType<typeof getDunningPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDunningPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDunningPolicy>>,
          TError,
          Awaited<ReturnType<typeof getDunningPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDunningPolicy<TData = Awaited<ReturnType<typeof getDunningPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDunningPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDunningPolicy>>,
          TError,
          Awaited<ReturnType<typeof getDunningPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDunningPolicy<TData = Awaited<ReturnType<typeof getDunningPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDunningPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le a politica de inadimplencia
 */

export function useGetDunningPolicy<TData = Awaited<ReturnType<typeof getDunningPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDunningPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDunningPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutDunningPolicyUrl = () => {




  return `/v1/dunning-policy`
}

/**
 * Define a politica de inadimplencia. Exclusiva de Super Admin e sensivel.
 *
 * O corpo nao carrega `provisional`: a politica deixa de ser provisoria por
 * ter sido definida com valores reais, e nao por alguem declarar que ela
 * nao e mais provisoria. Flag de ratificacao escrita pelo lado que ela
 * deveria bloquear nao e gate.
 * @summary Define a politica de inadimplencia
 */
export const putDunningPolicy = async (putDunningPolicyRequest: PutDunningPolicyRequest, options?: Parameters<typeof apiFetch>[1]): Promise<DunningPolicy> => {

  return apiFetch<DunningPolicy>(getPutDunningPolicyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putDunningPolicyRequest)
  }
);}





export const getPutDunningPolicyMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDunningPolicy>>, TError,{data: PutDunningPolicyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putDunningPolicy>>, TError,{data: PutDunningPolicyRequest}, TContext> => {

const mutationKey = ['putDunningPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putDunningPolicy>>, {data: PutDunningPolicyRequest}> = (props) => {
          const {data} = props ?? {};

          return  putDunningPolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutDunningPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putDunningPolicy>>>
    export type PutDunningPolicyMutationBody = PutDunningPolicyRequest
    export type PutDunningPolicyMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse

    /**
 * @summary Define a politica de inadimplencia
 */
export const usePutDunningPolicy = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDunningPolicy>>, TError,{data: PutDunningPolicyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putDunningPolicy>>,
        TError,
        {data: PutDunningPolicyRequest},
        TContext
      > => {
      return useMutation(getPutDunningPolicyMutationOptions(options), queryClient);
    }
    export const getListWebhookEventsUrl = (params?: ListWebhookEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/webhook-events?${stringifiedParams}` : `/v1/webhook-events`
}

/**
 * Lista a caixa de entrada de eventos de webhook com estado, tentativas e
 * ultimo erro. Exclusiva de Super Admin. E a fila que torna visivel o
 * evento fora de ordem, registrado como `ignored`, e o que falhou apos
 * cinco tentativas.
 * @summary Lista a caixa de entrada de eventos de webhook
 */
export const listWebhookEvents = async (params?: ListWebhookEventsParams, options?: Parameters<typeof apiFetch>[1]): Promise<WebhookEventPage> => {

  return apiFetch<WebhookEventPage>(getListWebhookEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWebhookEventsQueryKey = (params?: ListWebhookEventsParams,) => {
    return [
    `/v1/webhook-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWebhookEventsQueryOptions = <TData = Awaited<ReturnType<typeof listWebhookEvents>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListWebhookEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebhookEvents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWebhookEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWebhookEvents>>> = ({ signal }) => listWebhookEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWebhookEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWebhookEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listWebhookEvents>>>
export type ListWebhookEventsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListWebhookEvents<TData = Awaited<ReturnType<typeof listWebhookEvents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListWebhookEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebhookEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWebhookEvents>>,
          TError,
          Awaited<ReturnType<typeof listWebhookEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWebhookEvents<TData = Awaited<ReturnType<typeof listWebhookEvents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListWebhookEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebhookEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWebhookEvents>>,
          TError,
          Awaited<ReturnType<typeof listWebhookEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWebhookEvents<TData = Awaited<ReturnType<typeof listWebhookEvents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListWebhookEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebhookEvents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista a caixa de entrada de eventos de webhook
 */

export function useListWebhookEvents<TData = Awaited<ReturnType<typeof listWebhookEvents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListWebhookEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebhookEvents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWebhookEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReprocessWebhookEventUrl = (webhookEventId: string,) => {




  return `/v1/webhook-events/${webhookEventId}/reprocess`
}

/**
 * Reenfileira um evento de webhook que esta na fila de erro. Exclusiva de
 * Super Admin e sensivel: exige justificativa e grava auditoria. O
 * reprocessamento e idempotente pelo identificador do evento: reprocessar
 * um evento ja conciliado nao muda nada.
 * @summary Reprocessa um evento de webhook
 */
export const reprocessWebhookEvent = async (webhookEventId: string,
    reprocessWebhookEventRequest: ReprocessWebhookEventRequest, options?: Parameters<typeof apiFetch>[1]): Promise<WebhookEvent> => {

  return apiFetch<WebhookEvent>(getReprocessWebhookEventUrl(webhookEventId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reprocessWebhookEventRequest)
  }
);}





export const getReprocessWebhookEventMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessWebhookEvent>>, TError,{webhookEventId: string;data: ReprocessWebhookEventRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reprocessWebhookEvent>>, TError,{webhookEventId: string;data: ReprocessWebhookEventRequest}, TContext> => {

const mutationKey = ['reprocessWebhookEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reprocessWebhookEvent>>, {webhookEventId: string;data: ReprocessWebhookEventRequest}> = (props) => {
          const {webhookEventId,data} = props ?? {};

          return  reprocessWebhookEvent(webhookEventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReprocessWebhookEventMutationResult = NonNullable<Awaited<ReturnType<typeof reprocessWebhookEvent>>>
    export type ReprocessWebhookEventMutationBody = ReprocessWebhookEventRequest
    export type ReprocessWebhookEventMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Reprocessa um evento de webhook
 */
export const useReprocessWebhookEvent = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessWebhookEvent>>, TError,{webhookEventId: string;data: ReprocessWebhookEventRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reprocessWebhookEvent>>,
        TError,
        {webhookEventId: string;data: ReprocessWebhookEventRequest},
        TContext
      > => {
      return useMutation(getReprocessWebhookEventMutationOptions(options), queryClient);
    }
    export const getReceiveStripeWebhookUrl = () => {




  return `/v1/webhooks/stripe`
}

/**
 * Recebe um evento da Stripe e o insere na caixa de entrada para
 * conciliacao assincrona.
 *
 * **Esta e a unica rota de escrita da plataforma sem sessao.** Ela nao e
 * publica no sentido de aberta: e autenticada por assinatura HMAC-SHA256 no
 * cabecalho `Stripe-Signature`, com tolerancia de 5 minutos no `timestamp`.
 * Assinatura invalida responde 400 e nada e gravado no ledger.
 *
 * O corpo e opaco de proposito: o formato pertence a Stripe, e declara-lo
 * aqui faria o contrato envelhecer a cada versao da API deles. A resposta e
 * sempre 200 quando o evento e aceito na caixa de entrada, mesmo que a
 * conciliacao seja assincrona — a Stripe repete o envio quando nao recebe
 * 200, e repetir um evento ja aceito seria trabalho sem efeito.
 * @summary Recebe um evento assinado da Stripe
 */
export const receiveStripeWebhook = async (opaqueWebhookPayload: OpaqueWebhookPayload, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getReceiveStripeWebhookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(opaqueWebhookPayload)
  }
);}





export const getReceiveStripeWebhookMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveStripeWebhook>>, TError,{data: OpaqueWebhookPayload}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof receiveStripeWebhook>>, TError,{data: OpaqueWebhookPayload}, TContext> => {

const mutationKey = ['receiveStripeWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receiveStripeWebhook>>, {data: OpaqueWebhookPayload}> = (props) => {
          const {data} = props ?? {};

          return  receiveStripeWebhook(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceiveStripeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof receiveStripeWebhook>>>
    export type ReceiveStripeWebhookMutationBody = OpaqueWebhookPayload
    export type ReceiveStripeWebhookMutationError = Problem

    /**
 * @summary Recebe um evento assinado da Stripe
 */
export const useReceiveStripeWebhook = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receiveStripeWebhook>>, TError,{data: OpaqueWebhookPayload}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receiveStripeWebhook>>,
        TError,
        {data: OpaqueWebhookPayload},
        TContext
      > => {
      return useMutation(getReceiveStripeWebhookMutationOptions(options), queryClient);
    }
